import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList, fetchDelete } from '@/api/PMS/baseInformation/meterType';
import waves from '@/directive/waves'; // 水波纹指令

import instrumentAdd from './add';
export default {
  components: {
    instrumentAdd: instrumentAdd
  },
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        meterName: ''
      },
      title: '',
      meterId: '',
      multipleSelection: [],
      dialogFormVisible: false
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogFormVisible = false;
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      fetchList(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        console.log(_this.list);
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 创建
    handleCreate: function handleCreate() {
      this.meterId = '';
      this.title = '添加';
      this.dialogFormVisible = true;
    },
    // 编辑
    handleUpdate: function handleUpdate(meterId) {
      this.meterId = meterId;
      this.title = '编辑';
      this.dialogFormVisible = true;
    },
    delete: function _delete(meterIds) {
      var _this2 = this;

      if (meterIds.length > 0) {
        this.$confirm('你确定是要删除这些仪表, 是否继续?', '提示').then(function () {
          fetchDelete(meterIds).then(function (response) {
            if (response.data.code === 200) {
              _this2.getList();

              _this2.Alert({
                alertType: 'delete'
              });
            }
          });
        });
      } else {
        this.Alert({
          alertType: 'nodata'
        });
      }
    },
    handleDelete: function handleDelete(meterId) {
      var meterIds = [];
      meterIds.push(meterId);
      this.delete(meterIds);
    },
    handleDeletes: function handleDeletes() {
      var meterIds = [];
      this.multipleSelection.forEach(function (row) {
        meterIds.push(row.meterId);
      });
      this.delete(meterIds);
    }
  }
};